import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'datePicker',
    theme => `
		display: inline-block;
		max-width: 100%;
		width: 300px;
		padding: 12px 15px;
		border: 1px solid ${theme.color.text.B};
		border-radius: 3px;
		background-color: ${theme.color.text.white};
		box-sizing: border-box;
	`
  ],
  [
    'header',
    `
		display: flex;
		justify-content: space-around;
		margin: 10px 0;
	`
  ],
  [
    'selector',
	theme => `
		:lang(ar) {
			transform: scaleX(-1);
		}
		color: ${theme.color.primary.default};
		border-color: ${theme.color.primary.default};
		border-radius: 4px;
		background-color: ${theme.color.text.white};
		min-width: 60px;
		outline: none;
	`
  ]
]);
